// 로고 기다림 — 10/8 사장님 「풀이나 다른걸 기다리는 로딩」에 로고 애니메이션 2번(「만든 로고 영상은 두개다 사용하자」) · 「이미 물방울이 채워지잖아 그냥 밑에 게이지는 빼」
// 로고(달과 방울)의 물방울 자리에 흐린 빈 유리 그릇이 있고 그 위에 달이 떠 있다. 달 끝에서 작은 물방울이 스프링으로 맺혀 늘어나며 떨어지고, 그릇 물에 닿으면 물결이 출렁인다.
// 차오른 물 높이 = 진행(막대 없음). 다 되면 물이 가득 차고 달이 스프링으로 내려와 로고가 되고 「톡」 한 번 커졌다 돌아온다.
// 움직임 값은 참고 영상(make_wait_g.py · common_g.py — 머티리얼 3 익스프레시브 스프링 빠른 0.6/800 · 기본 0.8/380)을 로고 캔버스 1024 단위로 옮긴 것.
// 쓰는 법(큰 기다림): <canvas class="lw-art" aria-hidden="true"> 를 두고
//   BGWAIT.go(캔버스, { tau, reset }) — 띄울 때. 진행 값이 없으면 시간으로 천천히(점점 느리게, tau 초) 90% 쪽으로. 숨긴 지 20초 안에 다시 띄우면 이어서(reset 이면 처음부터)
//   BGWAIT.set(캔버스, 0~1)      — 실제 진행 값이 있는 곳만
//   await BGWAIT.done(캔버스)    — 실제로 끝났을 때. 남은 물을 고른 속도로 끝까지 채우고(남은 양에 비례 0.5~1.2초) → 정확히 가득 찬 뒤에 달이 내려오고 → 「톡」 → 풀린다.
//                                  부르는 쪽은 이 Promise 가 풀린 뒤에 덮개를 걷고 결과를 보인다(10/8 사장님 「왜 꽉 안 찼는데 시작이 되는거야?」).
//                                  0.4초 안에 끝난 기다림은 같은 순서로 짧게(채우기 0.3초). 한 장면도 그리기 전이면(덮개가 안 보였으면) 바로
//   BGWAIT.finished(캔버스)      — 마무리 중이면 그 끝, 아니면 바로 풀리는 Promise · BGWAIT.stop(캔버스) — 걷은 뒤 그리기를 멈춘다
// 글 칸 안의 작은 기다림: <i class="lw-mini" aria-hidden="true"></i> — CSS 만으로 돈다(물방울이 떨어지고 물이 천천히 찬다).
// 단추 글자 자리의 기다림: <i class="lw-mini lw-in" role="img" aria-label="불러오는 중…"></i> — 같은 .lw-mini 를 줄여 그린다(줄 높이보다 작게 자리를 잡아 단추 크기 · 자리가 그대로).
// 「동작 줄이기」면 움직임 없이 로고 한 장 — 빈 유리 그릇의 물 높이만 진행 따라 바뀐다(물결 · 떨어지는 방울 · 스프링 없음).
(() => {
  if (window.BGWAIT) return;
  const img = (src) => { const i = new Image(); i.decoding = "async"; i.src = src; return i; };   // 토스판은 toss.js 가 /brand/ 를 bamgwabi.com 으로 돌린다
  // 10/10 사장님 「3번으로 전부 변경하자」 — 테두리 네온판(tools/brand_neon.py). 빛이 번질 둘레까지 넓힌 그림이라 그릴 때는 MB · DB 를 둘레(MP · DP, 폭 · 높이 비율)만큼 넓힌 자리에 그린다
  // 그릇은 몸(테두리 · 안)과 바깥 빛을 나눈 두 장 — 몸만 물 높이로 자르고 바깥 빛은 차오른 만큼 밝아진다(물 높이에서 빛이 가로로 잘려 보이지 않게)
  const IM = { moon: img("/brand/wait-moon-neon-44ad2590e816.webp"), drop: img("/brand/wait-drop-neon-f686d95bae17.webp"), body: img("/brand/wait-drop-neon-body-79d190eff161.webp"), halo: img("/brand/wait-drop-neon-halo-bb80c860526c.webp") };
  const ok = (i) => i.complete && i.naturalWidth > 0;
  // 로고 캔버스(1024) 단위. 그림은 이 자리(x, y, 폭, 높이)를 잘라 0.6 배로 줄인 것(Icon Composer 유리 재질 — 검정은 투명, 둥근 사각 테두리 빛은 지움)
  const MB = [204, 215, 410, 431], DB = [555, 559, 210, 306];
  const MP = [0.4472, 0.4247], DP = [0.8730, 0.5978];
  const grow = (x, y, w, h, P) => [x - w * P[0], y - h * P[1], w * (1 + 2 * P[0]), h * (1 + 2 * P[1])];
  const MG = grow(...MB, MP), DG = grow(...DB, DP);
  const V = [180, -90, 610, 980];                                    // 그리는 범위 — 달이 300 위로 뜬 자리부터 「톡」 1.07 배까지
  const E = 100, VE = [V[0] - E, V[1] - E, V[2] + 2 * E, V[3] + 2 * E];   // 네온 빛이 잘리지 않게 사방 E 만큼 더 그리고, 그만큼 바깥 여백을 음수로 당겨 자리 · 크기는 그대로
  const RISE = 300, TIP = [612.4, 526], TOP = 560, BOT = 864, PIVOT = [484.5, 540];
  const G = 9176, DRIP = 0.62, GROW = 0.3, SW = DB[2] * 0.16, SH = DB[3] * 0.16;   // 중력(단위/초²) · 방울 사이 · 맺히는 시간 · 작은 방울 크기
  const FAST = [0.6, 800], DEF = [0.8, 380];
  const WAVE = 137.6, A0 = 4.6, HIT = 21.4;                          // 물결 길이 · 잔물결 · 방울이 닿을 때 출렁(점점 잦아듦)
  const POP = 0.32, END = 0.7, FILL_DRIP = 0.34;                     // 마무리: 가득 찬 때부터 「톡」까지 · 끝까지(초) · 채우는 동안 방울 사이(조금 빨라진다)
  const SHORT = 0.4, CAP = 0.9, TAU = 12;
  const reduce = () => !!window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
  const spring = (t, z, k) => {                                       // 0 → 1 스프링(질량 1, 처음 속도 0)
    if (t <= 0) return 0;
    const w = Math.sqrt(k);
    if (z < 1) { const wd = w * Math.sqrt(1 - z * z); return 1 - Math.exp(-z * w * t) * (Math.cos(wd * t) + (z * w / wd) * Math.sin(wd * t)); }
    return 1 - Math.exp(-w * t) * (1 + w * t);
  };
  const full = (st) => st.fin && st.fin.tm != null;                  // 정확히 가득 찼다(그 뒤에만 달이 내려온다)
  const lift = (st) => (st.rm ? 0 : full(st) ? RISE * (1 - spring(st.t - st.fin.tm, ...DEF)) : RISE);

  const live = new Set();
  let raf = 0, last = 0;
  function fit(c) {
    const w = c.clientWidth || 150, W = Math.round(w * Math.min(3, window.devicePixelRatio || 1)), H = Math.round((W * VE[3]) / VE[2]);
    if (c.width !== W || c.height !== H) { c.width = W; c.height = H; }
  }
  function finish(st) { if (st.fin && !st.fin.done) { st.fin.done = true; st.fin.res(); } }
  function step(st, dt) {
    st.t += dt;
    const t = st.t;
    if (st.fin) {                                                     // 남은 물을 고른 속도로 — 스프링으로 튀지 않는다
      if (!full(st)) { st.p = Math.min(1, st.fin.p0 + ((1 - st.fin.p0) * (t - st.fin.t)) / st.fin.dur); if (st.p >= 1) { st.p = 1; st.fin.tm = t; } }
      else if (t >= st.fin.tm + END) finish(st);
    }
    else {
      st.goal = Math.max(st.goal, st.real ?? CAP * (1 - Math.exp(-t / st.tau)));
      st.p += (st.goal - st.p) * (st.rm ? 1 : 1 - Math.exp(-dt / 0.35));
    }
    if (st.rm) return;
    const level = BOT - (BOT - TOP) * st.p, tipY = TIP[1] - lift(st);
    if (!full(st)) while (st.next <= t) { st.drops.push({ t0: st.next, y0: null }); st.next += st.fin ? FILL_DRIP : DRIP; }
    st.drops = st.drops.filter((d) => {
      const u = t - d.t0;
      if (u < GROW) return !full(st);                                 // 맺히는 중 — 가득 차면 지운다(떨어지던 것은 끝까지)
      if (d.y0 == null) d.y0 = tipY;
      const v = u - GROW;
      if (d.y0 + 0.5 * G * v * v + SH * 0.6 >= level) { st.hits.push(t); return false; }
      return true;
    });
    st.hits = st.hits.filter((h) => t - h < 2.5);
  }
  function paint(c) {
    const st = c._lw, x = c.getContext("2d"), s = c.width / VE[2];
    x.setTransform(1, 0, 0, 1, 0, 0); x.clearRect(0, 0, c.width, c.height);
    if (!Object.values(IM).every(ok)) return;
    x.setTransform(s, 0, 0, s, -VE[0] * s, -VE[1] * s);
    const t = st.t, pp = full(st) && !st.rm ? t - st.fin.tm - POP : -1;
    const sc = pp > 0 ? 1 + 0.07 * (spring(pp, ...FAST) - spring(pp - 0.12, ...FAST)) : 1;
    if (sc !== 1) { x.translate(PIVOT[0], PIVOT[1]); x.scale(sc, sc); x.translate(-PIVOT[0], -PIVOT[1]); }
    x.globalAlpha = 0.22 + 0.78 * st.p; x.drawImage(IM.halo, ...DG);
    x.globalAlpha = 0.22; x.drawImage(IM.body, ...DG); x.globalAlpha = 1;   // 흐린 빈 유리 그릇
    const level = BOT - (BOT - TOP) * st.p;
    let A = st.rm ? 0 : A0 + st.hits.reduce((a, h) => a + HIT * Math.exp(-3.2 * (t - h)), 0);
    if (full(st)) A *= Math.max(0, 1 - (t - st.fin.tm) * 2.5);       // 가득 찬 뒤에 잔잔해진다
    if (st.p > 0.002) {                                               // 차오른 물 — 물결 아래만 유리 물방울
      x.save(); x.beginPath(); x.moveTo(DG[0], DG[1] + DG[3]);
      for (let px = DG[0]; px <= DG[0] + DG[2] + 6; px += 6) x.lineTo(px, level + A * Math.sin((2 * Math.PI * px) / WAVE - 6 * t));
      x.lineTo(DG[0] + DG[2] + 6, DG[1] + DG[3]); x.closePath(); x.clip();
      x.drawImage(IM.body, ...DG); x.restore();
    }
    if (!st.rm) {
      const tipY = TIP[1] - lift(st);
      for (const d of st.drops) {
        const u = t - d.t0;
        if (u < GROW) { const k = Math.max(0.05, spring(u, ...FAST)), w = SW * k, h = SH * k * (1 + 0.15 * (1 - k)); x.drawImage(IM.drop, ...grow(TIP[0] - w / 2, tipY - h * 0.35, w, h, DP)); }
        else { const v = u - GROW, sd = Math.min(0.45, 1.5 * v), w = SW * (1 - 0.25 * sd), h = SH * (1 + sd); x.drawImage(IM.drop, ...grow(TIP[0] - w / 2, d.y0 + 0.5 * G * v * v - h * 0.35, w, h, DP)); }
      }
    }
    x.drawImage(IM.moon, MG[0], MG[1] - lift(st), MG[2], MG[3]);
  }
  function tick(now) {
    raf = 0;
    const dt = Math.min(0.05, last ? (now - last) / 1000 : 1 / 60); last = now;
    for (const c of live) {
      const st = c._lw;
      if (!c.isConnected || !st) { live.delete(c); if (st) finish(st); continue; }   // 10/8 감시 점검 — 떨어진 캔버스의 done 을 기다리던 쪽(결과 펼치기)이 영영 멈추지 않게 풀어 준다
      step(st, dt); paint(c);
      if (st.fin?.done) live.delete(c);                               // 로고가 된 채로 멈춰 둔다(걷는 것은 부른 쪽)
    }
    if (live.size) raf = requestAnimationFrame(tick); else last = 0;
  }
  function go(c, o = {}) {
    if (!c) return;
    let st = c._lw;
    if (!st || st.fin || o.reset || (st.off && performance.now() - st.off > 20000)) {
      if (st) finish(st);
      st = c._lw = { t: 0, p: 0, goal: 0, real: null, drops: [], hits: [], next: 0, tau: TAU, fin: null, off: 0, rm: false, timer: 0 };
    }
    st.off = 0; if (o.tau) st.tau = o.tau;
    st.rm = reduce(); fit(c); clearInterval(st.timer);
    if (st.rm) { step(st, 0); paint(c); st.timer = setInterval(() => { step(st, 1); paint(c); }, 1000); return; }   // 움직임 없이 — 물 높이만 1초마다
    live.add(c); if (!raf) raf = requestAnimationFrame(tick);
  }
  function set(c, p) {
    const st = c?._lw;
    if (!st || st.fin || p == null || !(p >= 0)) return;
    st.real = Math.max(st.real ?? 0, Math.min(0.97, p));              // 가득 채우기는 done 만
    if (st.rm) { step(st, 0); paint(c); }
  }
  function done(c) {
    const st = c?._lw;
    if (!st) return Promise.resolve();
    if (st.fin) return st.fin.promise;
    const fin = st.fin = { t: st.t, p0: st.p, dur: st.t < SHORT ? 0.3 : 0.5 + 0.7 * (1 - st.p), tm: null, done: false };   // 채우는 시간은 남은 양에 비례(0.4초 안의 짧은 기다림은 0.3초)
    fin.promise = new Promise((r) => { fin.res = r; });
    if (st.rm || !st.t || !live.has(c)) { clearInterval(st.timer); st.p = 1; fin.tm = st.t; paint(c); finish(st); }   // 움직임 없이 가득 찬 로고 한 장(동작 줄이기 · 한 장면도 안 그렸을 때)
    return fin.promise;
  }
  const finished = (c) => (c?._lw?.fin && !c._lw.fin.done ? c._lw.fin.promise : Promise.resolve());
  function stop(c) {
    const st = c?._lw;
    if (!st) return;
    live.delete(c); clearInterval(st.timer); st.off = performance.now(); finish(st);
  }
  window.addEventListener("resize", () => { for (const c of live) fit(c); });

  // 글 칸 안의 작은 기다림(.lw-mini, 폭 34px) — 같은 그림 · 같은 자리, 달은 150 만 띄워 작게. 물방울은 그릇 뒤로 떨어져 물에 가려지고, 물은 45초 동안 점점 느리게 90% 쪽으로
  const U = 34 / 570, px = (n) => `${(n * U).toFixed(2)}px`, X0 = 200 - E, Y0 = 60 - E, ML = 150;   // 큰 기다림처럼 사방 E 만큼 넓혀 그리고 여백을 음수로
  const tipX = TIP[0] - X0, tipY = TIP[1] - ML - Y0, moonSP = `${px(MG[2])} ${px(MG[3])}`, moonPos = `${px(MG[0] - X0)} ${px(MG[1] - ML - Y0)}`;
  const dripAt = (k, sx, sy, y) => { const [l, t, w, h] = grow(tipX - (SW * k * sx) / 2, y - SH * k * sy * 0.35, SW * k * sx, SH * k * sy, DP); return `background-size:${px(w)} ${px(h)},${moonSP};background-position:${px(l)} ${px(t)},${moonPos}`; };
  const lv = (p) => `${(((BOT - (BOT - TOP) * p - DG[1]) / DG[3]) * 100).toFixed(1)}%`;
  const box = (src) => `position:absolute;left:${px(DG[0] - X0)};top:${px(DG[1] - Y0)};width:${px(DG[2])};height:${px(DG[3])};background:url("${src}") 0 0/100% 100% no-repeat;content:""`;
  const st = document.createElement("style");
  st.textContent = `.lw-art{display:block;flex:none;width:calc(min(150px,38vw) * ${(VE[2] / V[2]).toFixed(4)});height:calc(min(150px,38vw) * ${(VE[3] / V[2]).toFixed(4)});margin:calc(min(150px,38vw) * ${(-E / V[2]).toFixed(4)})}
.lw-mini{position:relative;display:block;flex:none;width:${px(570 + 2 * E)};height:${px(810 + 2 * E)};margin:${px(-E)};background-image:url("${IM.drop.src}"),url("${IM.moon.src}");background-repeat:no-repeat;${dripAt(0, 1, 1, tipY)};animation:lwdrip .9s infinite}
.lw-mini::before{${box(IM.drop.src)};opacity:.22}
.lw-mini::after{${box(IM.body.src)};clip-path:inset(${lv(0.06)} 0 0 0);animation:lwfill 45s cubic-bezier(.1,.7,.3,1) forwards}
@keyframes lwdrip{0%{${dripAt(0, 1, 1, tipY)};animation-timing-function:cubic-bezier(.34,1.56,.64,1)}32%{${dripAt(1, 1, 1, tipY)};animation-timing-function:cubic-bezier(.55,0,1,.45)}100%{${dripAt(1, 0.8, 1.35, BOT - Y0 - 40)}}}
@keyframes lwfill{to{clip-path:inset(${lv(CAP)} 0 0 0)}}
.lw-mini.lw-in{display:inline-block;vertical-align:middle;margin:-23px -15px;transform:scale(.45)}
@media (prefers-reduced-motion:reduce){.lw-mini{animation:none;${dripAt(0, 1, 1, tipY)}}.lw-mini::after{animation:none;clip-path:inset(${lv(0.5)} 0 0 0)}}`;
  document.head.appendChild(st);
  window.BGWAIT = { go, set, done, finished, stop };
})();
